import { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import PageHeader from '../components/layout/PageHeader';

const HEADER_BG = 'https://images.unsplash.com/photo-1758599543129-5269a8f29e68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGhhbmRzaGFrZSUyMHBhcnRuZXJzaGlwJTIwZGVhbCUyMGNvcnBvcmF0ZXxlbnwwfHx8fDE3NzI0NDAyNjV8MA&ixlib=rb-4.1.0&q=85';
const API_URL = process.env.REACT_APP_BACKEND_URL;

const BecomeVendorPartner = () => {
  const [form, setForm] = useState({ company_name: '', contact_name: '', email: '', phone: '', website: '', specialization: '', team_size: '', regions: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(`${API_URL}/api/vendor-partner`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
    } catch (err) { console.error('Submit error:', err); }
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <div data-testid="become-vendor-partner-page">
      <PageHeader caption="Partnership" title="Become a Vendor Partner" subtitle="Join our vendor network and access enterprise staffing opportunities." bgImage={HEADER_BG} />

      <section className="bg-white sol-section">
        <div className="sol-container">
          <div className="max-w-2xl mx-auto">
            <div className="bg-[#F5F5F5] p-8 md:p-12">
              {submitted ? (
                <div data-testid="vendor-partner-success" className="text-center py-12">
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>Application Received</h3>
                  <p className="text-[#525252] mb-6">Thank you for your interest in partnering with Solnity. Our partnership team will review your application and respond within 48 hours.</p>
                  <button onClick={() => { setSubmitted(false); setForm({ company_name: '', contact_name: '', email: '', phone: '', website: '', specialization: '', team_size: '', regions: '', message: '' }); }} className="sol-btn-outline text-sm">Submit Another Application</button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-testid="vendor-partner-form">
                  <h3 className="text-xl font-semibold mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>Vendor Partnership Application</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Company Name *</label><input name="company_name" value={form.company_name} onChange={handleChange} required className="sol-input" placeholder="Your Company" data-testid="vendor-company-input" /></div>
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Contact Person *</label><input name="contact_name" value={form.contact_name} onChange={handleChange} required className="sol-input" placeholder="Full Name" data-testid="vendor-contact-input" /></div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Email *</label><input name="email" type="email" value={form.email} onChange={handleChange} required className="sol-input" placeholder="contact@company.com" data-testid="vendor-email-input" /></div>
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Phone *</label><input name="phone" value={form.phone} onChange={handleChange} required className="sol-input" placeholder="+1 (555) 000-0000" data-testid="vendor-phone-input" /></div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Website</label><input name="website" value={form.website} onChange={handleChange} className="sol-input" placeholder="https://yourcompany.com" data-testid="vendor-website-input" /></div>
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Specialization *</label>
                      <select name="specialization" value={form.specialization} onChange={handleChange} required className="sol-select" data-testid="vendor-spec-select">
                        <option value="">Select area</option><option value="it-staffing">IT Staffing</option><option value="healthcare">Healthcare IT</option><option value="finance">Financial Services</option><option value="engineering">Engineering</option><option value="general">General Staffing</option>
                      </select>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Team Size</label>
                      <select name="team_size" value={form.team_size} onChange={handleChange} className="sol-select" data-testid="vendor-team-select">
                        <option value="">Select size</option><option value="1-10">1-10 Recruiters</option><option value="11-50">11-50 Recruiters</option><option value="51-100">51-100 Recruiters</option><option value="100+">100+ Recruiters</option>
                      </select>
                    </div>
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Operating Regions</label><input name="regions" value={form.regions} onChange={handleChange} className="sol-input" placeholder="e.g. USA, Canada" data-testid="vendor-regions-input" /></div>
                  </div>
                  <div className="mb-6"><label className="block text-sm font-medium text-[#333333] mb-2">Additional Information</label><textarea name="message" value={form.message} onChange={handleChange} className="sol-textarea" placeholder="Tell us about your company and why you'd like to partner with Solnity..." data-testid="vendor-message-input" /></div>
                  <button type="submit" disabled={loading} data-testid="vendor-submit-btn" className="sol-btn-primary w-full text-sm">
                    {loading ? 'Submitting...' : 'Submit Partnership Application'} <ArrowRight className="w-4 h-4" />
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BecomeVendorPartner;
